import { render } from "./MiningWeDontKnow.vue?vue&type=template&id=45dbd7a4"
import script from "./MiningWeDontKnow.vue?vue&type=script&lang=js"
export * from "./MiningWeDontKnow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__